<template>
  
  <div class="group" :ref="refs['measurementsGroup']" data-id="measurementsGroup">

    <div class="group-header">
      <div class="group-title">What are the measurements of the space?</div>
      <div class="group-help">Not sure? <a href="/support/how-to-measure/" target="_blank">See how to measure.</a></div>
    </div>

    <div class="group-inputs">

      <div class="group-input" :ref="refs['widthGroup']">

        <Input
        key="width"
        field-label="Width"
        field-name="width"
        field-type="number"
        :init-value=initialValue
        :max=maxWidth
        :min=minWidth
        :required="true"
        scope="specs"
        @update-value="updateValue"
        @live-value="liveValue"
        ></Input>
        
      </div>

    </div>

    <div class="group-footer">

      <small v-if="builder.currentSectionHasCorner"><strong>This section requires hanging going into the corner</strong></small>
      
      <small>Standard maximum height 2000mm</small>

      <p v-if="enteredValue && enteredValue < minWidth" style="font-size: 90%; color:#f00;"><strong>The minimum with of section 2 for a U-shape Walk-in Wardrobe is 2000mm. To continue using the width you've entered please choose an L-shape to design a functional Walk-in Wardrobe.</strong></p>
    
    </div>   

  </div>
  
</template>

<script setup>
  
import { ref, computed } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const enteredValue = ref(null);

function updateValue(prop, val) {
  builder.setCurrentSectionSpec(prop, val);
}

function liveValue(prop, val) {
  if (val > builder.currentProductStructure.sections.sections.width.min) {
    enteredValue.value = val;
  } else {
    enteredValue.value = null;
  }
}

const initialValue = computed(() => {
  if (!_.isUndefined(builder.currentSection) && !_.isUndefined(builder.currentSection.width)) {
    return builder.currentSection.width;
  }
  return null;
})

enteredValue.value = initialValue.value;

const minWidth = computed(() => {
  const layoutSection = builder.currentItem.productLayoutSections[builder.sectionIndex];
  console.log(layoutSection);
  if (layoutSection && layoutSection.minWidth) return layoutSection.minWidth;
  return builder.currentProductStructure.sections.sections.width.min
})

const maxWidth = computed(() => {
  return builder.currentProductStructure.sections.sections.width.max
})

// init refs
let refHandles = [
  'measurementsGroup',
  'widthGroup',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>